import { Box, SvgIcon, useMediaQuery } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as Auto } from 'assets/images/icons/Auto.svg';
import { ReactComponent as Cold } from 'assets/images/icons/Cold.svg';
import { ReactComponent as Fan } from 'assets/images/icons/controller.svg';
import { ReactComponent as Drop } from 'assets/images/icons/Drop.svg';
import { ReactComponent as Heat } from 'assets/images/icons/Heat.svg';
import { useEffect } from 'react';
import { brandColors } from 'types/colors';
import { modeValueStyle } from '../styles/style.js';

const modes = [
  { key: 'Cool', value: 'cool', Icon: Cold, modeColor: brandColors.BLUE },
  { key: 'Heat', value: 'heat', Icon: Heat, modeColor: brandColors.RED },
  { key: 'FanOnly', value: 'fan', Icon: Fan, modeColor: brandColors.BLACK },
  // { key: 'Dry', value: 4, Icon: Drop, modeColor: brandColors.BLACK },
  { key: 'Auto', value: 'auto', Icon: Auto, modeColor: brandColors.BLACK },
];
const modeIconStyle = {
  scale: '2',
  color: brandColors.BLUE,
};
const fourOptionSelectorStyle = {
  display: 'flex',
  justifyContent: 'flex-start',
  width: '11rem',
  ml: 1.5,
  gap: '0.6rem',
  flex: '0 0 11rem',
};

export default function ModeSelector({
  control,
  unitOnOffStatus,
  selectedMode,
  setSelectedMode,
  currMode,
  onManualSelect,
  controllerModel,
  isRelayModel = false,
  allowedModeKeys,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // when DCV is enabled we manage the highlight locally
  /* keep local selection in sync if DCV is toggled off/on
     or currMode changes from outside */
  useEffect(() => {
    if (control !== 'manual') {
      setSelectedMode(selectedMode);
    }
  }, [selectedMode, control]);

  const isActive = mode => (control === 'manual' ? selectedMode === mode : currMode === mode);
  const controllerModes =
    controllerModel === 'HY01AC' ? modes.filter(({ key }) => key !== 'Auto') : modes;
  const visibleModes = allowedModeKeys
    ? controllerModes.filter(({ key }) => allowedModeKeys.includes(key))
    : controllerModes;
  const hasFourOptions = visibleModes.length === 4;
  const isSelectable = control === 'manual' || control === 'solai' || isRelayModel;

  return (
    <Box
      sx={
        hasFourOptions
          ? fourOptionSelectorStyle
          : {
              display: 'flex',
              gap: isSmallScreen ? (visibleModes.length === 2 ? 9 : 1) : 1,
              justifyContent: isSmallScreen
                ? 'flex-end'
                : visibleModes.length === 2
                  ? 'space-evenly'
                  : 'space-between',
              width: '100%',
              ml: 1.5,
            }
      }>
      {visibleModes.map(({ key, value, Icon, modeColor }) => (
        <Tooltip
          title={
            unitOnOffStatus === false ? (
              <div style={{ textAlign: 'center' }}>
                {key}
                <br />
                <p style={{ fontSize: '.8rem' }}>unit is currently OFF</p>
              </div>
            ) : (
              key
            )
          }
          placement="bottom">
          <Box
            key={key}
            onClick={
              isSelectable
                ? () => {
                    onManualSelect?.(value);
                    setSelectedMode(value);
                  }
                : undefined
            }
            sx={{
              ...modeValueStyle,
              cursor: isSelectable ? 'pointer' : 'default',
              border: isActive(value)
                ? unitOnOffStatus === false
                  ? `2px solid ${brandColors.GREY}`
                  : `2px solid ${modeColor}`
                : `1px solid ${brandColors.GREY_LIGHT}`,
              transition: 'transform 0.2s ease', // ← applies to both hover in & out

              '&:hover':
                isSelectable
                  ? {
                      transform: 'scale(1.07)',
                      boxShadow: '0px 0px 5px 0px #000000',
                    }
                  : {},
            }}>
            <SvgIcon
              sx={{
                ...modeIconStyle,
                color:
                  unitOnOffStatus === false
                    ? isActive(value)
                      ? brandColors.GREY_DARK
                      : brandColors.GREY
                    : isActive(value)
                      ? modeColor
                      : brandColors.GREY_DARK,
              }}>
              <Icon />
            </SvgIcon>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}
